import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import SettingsClassic from './settings-classic';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: SettingsClassic,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        return super.createObj(objectName, params);
    }
}

export {Factory};
